import { NextSeo } from 'next-seo';
import { PrimitiveType, useIntl } from 'react-intl';

import { notEmpty } from 'utils/typescript.utils';

interface Props {
  titleSuffix: string;
  titleIntlId: string;
  values?: Record<string, PrimitiveType>;
}

/**
 *
 * Used when the page is not in DatoCMS (auth, account, etc.)
 */
const BasicSeo = ({ titleSuffix, titleIntlId, values }: Props) => {
  const intl = useIntl();
  const seoTitle = [
    intl.formatMessage({ id: titleIntlId }, values),
    titleSuffix,
  ]
    .filter(notEmpty)
    .join('');

  return <NextSeo title={seoTitle} noindex nofollow />;
};

export default BasicSeo;
